import { ReactNode } from "react"
import './SlideContentHeader.scss';

interface SildeContentHeaderProps {
    children: ReactNode
}

export default function SildeContentHeader({ children }: Readonly<SildeContentHeaderProps>) {
    return (
        <div className="slide-content-header">
            {children}
        </div>
    )
}